import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import api from "@/lib/api";
import { reveal } from "@/lib/motion";

export default function Courses() {
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    api.get("/courses").then((r) => setCourses(r.data)).catch(() => {});
  }, []);

  return (
    <section
      id="courses"
      data-testid="courses-section"
      className="relative py-28 md:py-40 max-w-[1400px] mx-auto px-6 md:px-10"
    >
      <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-20">
        <div className="md:col-span-3">
          <span className="overline text-primary">01 — Programmes</span>
        </div>
        <h2 className="md:col-span-8 font-display font-bold tracking-tight text-4xl md:text-6xl leading-[1.02]">
          Three paths, one living language.
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-border border border-border">
        {courses.map((c, i) => (
          <motion.article
            key={c._id || i}
            data-testid={`course-card-${i}`}
            variants={reveal}
            custom={i}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-80px" }}
            className="group relative bg-background p-8 md:p-10 min-h-[380px] flex flex-col justify-between hover:bg-primary transition-colors duration-500"
          >
            <div className="flex items-start justify-between">
              <span className="font-deva text-7xl md:text-8xl text-primary/80 group-hover:text-primary-foreground leading-none transition-colors duration-500">
                {c.devanagari || "अ"}
              </span>
              <span className="overline text-muted-foreground group-hover:text-primary-foreground/70 transition-colors duration-500">
                {c.level}
              </span>
            </div>

            <div>
              <p className="overline text-muted-foreground group-hover:text-primary-foreground/70 mb-3 transition-colors duration-500">
                {c.subtitle}
              </p>
              <h3 className="font-display font-bold text-2xl md:text-3xl tracking-tight mb-4 group-hover:text-primary-foreground transition-colors duration-500">
                {c.title}
              </h3>
              <p className="font-body text-sm text-muted-foreground group-hover:text-primary-foreground/90 leading-relaxed transition-colors duration-500">
                {c.description}
              </p>
              <p className="mt-6 font-body text-xs text-foreground/60 group-hover:text-primary-foreground/80 transition-colors duration-500">
                Duration · {c.duration}
              </p>
            </div>
          </motion.article>
        ))}
      </div>
    </section>
  );
}
